import { STAKING_STATUS_LABEL_MAP } from "constants/stake";

export const getStakingStatusLabel = (status) => {
  if (!status) return "";

  const normalizedStatus = String(status).trim().toLowerCase();

  return STAKING_STATUS_LABEL_MAP[normalizedStatus] || String(status);
};
